import { SocketChannelNamespaceType } from "@/constant/export/SocketChannelNamespaceType";

const ablyChannelCoreNamespace =
  import.meta.env.VITE_ABLY_CHANNEL_CORE_NAMESPACE ?? "hpoll-quest-socket-core";
const ablyChannelSyncNamespace =
  import.meta.env.VITE_ABLY_CHANNEL_SYNC_NAMESPACE ?? "hpoll-quest-socket-sync";
const ablyChannelPrivateNamespace =
  import.meta.env.VITE_ABLY_CHANNEL_PRIVATE_NAMESPACE ??
  "hpoll-quest-socket-private";
// Must equal hqb-ai-agent's ABLY_CHANNEL_AI_ASSISTANT_NAMESPACE.
const ablyChannelAIAssistantNamespace =
  import.meta.env.VITE_ABLY_CHANNEL_AI_ASSISTANT_NAMESPACE ??
  "hpoll-quest-socket-ai-assistant";

export const getChannelName = (clientId: string, namespaceType: string) => {
  let channelNameSpaceType;
  switch (namespaceType) {
    case SocketChannelNamespaceType.CORE:
      channelNameSpaceType = ablyChannelCoreNamespace;
      break;
    case SocketChannelNamespaceType.SYNC:
      channelNameSpaceType = ablyChannelSyncNamespace;
      break;
    case SocketChannelNamespaceType.PRIVATE:
      channelNameSpaceType = ablyChannelPrivateNamespace;
      break;
    case SocketChannelNamespaceType.AI_ASSISTANT:
      channelNameSpaceType = ablyChannelAIAssistantNamespace;
      break;
    default:
      channelNameSpaceType = ablyChannelPrivateNamespace;
      break;
  }

  return `${channelNameSpaceType}:${clientId}`;
};

export const getChannel = (
  ablyClient: any,
  clientId: string,
  namespaceType: string
) => {
  if (!ablyClient) return null;

  const channelName = getChannelName(clientId, namespaceType);
  return ablyClient.channels.get(channelName);
};

export const subscribeToCoreChannel = (
  ablyClient: any,
  clientId: string,
  eventName: string,
  callback: any
) => {
  const channel = getChannel(
    ablyClient,
    clientId,
    SocketChannelNamespaceType.CORE
  );
  if (channel) {
    channel.subscribe(eventName, callback);
  }
};

export const subscribeToSyncChannel = (
  ablyClient: any,
  clientId: string,
  eventName: string,
  callback: any
) => {
  const channel = getChannel(
    ablyClient,
    clientId,
    SocketChannelNamespaceType.SYNC
  );
  if (channel) {
    channel.subscribe(eventName, callback);
  }
};

export const subscribeToPrivateChannel = (
  ablyClient: any,
  clientId: string,
  eventName: string,
  callback: any
) => {
  const channel = getChannel(
    ablyClient,
    clientId,
    SocketChannelNamespaceType.PRIVATE
  );
  if (channel) {
    channel.subscribe(eventName, callback);
  }
};

export const unsubscribeFromPrivateChannel = (
  ablyClient: any,
  clientId: string,
  eventName: string,
  callback: any
) => {
  const channel = getChannel(
    ablyClient,
    clientId,
    SocketChannelNamespaceType.PRIVATE
  );
  if (channel) {
    channel.unsubscribe(eventName, callback);
  }
};

export const parseMessage = (message: any) => {
  try {
    return JSON.parse(message);
  } catch (error) {
    return null;
  }
};
